import apiClient from '../apiClient';

class InvoiceOrganisationService {
  async getAll() {
    const response = await apiClient.get('/invoice-organisations');
    return response || [];
  }

  async create(data) {
    return await apiClient.post('/invoice-organisations', data);
  }

  async update(id, data) {
    return await apiClient.patch(`/invoice-organisations/${id}`, data);
  }

  async delete(id) {
    return await apiClient.delete(`/invoice-organisations/${id}`);
  }
}

export default InvoiceOrganisationService;
